export default "__VITE_ASSET__BSsVmp6I__"